import types from './types';

export const loadProduct = (payload) => (dispatch) => dispatch({
  type: types.LOAD_PRODUCT,
  payload
});
